
import GenreMaker from '../anychart/genreMaker'; 

var HeatMapChart = class HeatMapChart extends GenreMaker {

    setData(state){
        console.log("entry heatmap");
       
        super.setData(state);
        this.chart = anychart.heatMap(this.data);
        return this.chart;
    }

    createChart(){
        return null;
    }; 
};
    
GenreMaker.heatmap = HeatMapChart;

export var HeatMapChart;



// WEBPACK FOOTER //
// ./src/anychart/heatMapChart.js